const isSurchargeUnknown = charges => {
  if (Array.isArray(charges)) {
    return charges.every(amount => amount === null);
  }

  return false;
};

export default isSurchargeUnknown;
